import { render, staticRenderFns } from "./PagePreview.vue?vue&type=template&id=537b17df"
import script from "./PagePreview.vue?vue&type=script&lang=js"
export * from "./PagePreview.vue?vue&type=script&lang=js"
import style0 from "./PagePreview.vue?vue&type=style&index=0&id=537b17df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports